"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayRequirementType = void 0;
var GiveawayRequirementType;
(function (GiveawayRequirementType) {
    GiveawayRequirementType["EMAIL"] = "email";
    GiveawayRequirementType["NONZERO_BALANCE"] = "nonZeroBalance";
    GiveawayRequirementType["ALLOWLIST"] = "allowlist";
    GiveawayRequirementType["TWITTER_FOLLOW"] = "twitterFollow";
    GiveawayRequirementType["TWITTER_LIKE"] = "twitterLike";
    GiveawayRequirementType["TWITTER_RETWEET"] = "twitterRetweet";
})(GiveawayRequirementType || (exports.GiveawayRequirementType = GiveawayRequirementType = {}));
//# sourceMappingURL=Giveaways.js.map